/** Parse JSON error bodies returned inside blob responses (common with axios responseType: 'blob'). */
export async function parseApiBlobError(error: any, fallback = 'Request failed'): Promise<string> {
  const data = error?.response?.data;
  if (!data) return error?.message || fallback;

  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text);
      return parsed?.message || fallback;
    } catch {
      return fallback;
    }
  }

  if (typeof data === 'object' && data.message) return data.message;
  return fallback;
}
